export const routes = [
  {
    path: 'custom-menu/:menuId',
    name: 'custom_menu_viewer',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: () => import('./CustomMenuViewer.vue'),
  },
];
